import { LoaderFunctionArgs } from 'react-router-dom'
import { getStats } from '../../action/courses'

export const coursesLoader = async ( args: LoaderFunctionArgs ) => {

    await getStats()

}